import React from "react";

const Footer = () => {
  return (
    <div className="footer" style={{ overflow: "hidden" }}>
      <h2 className="px-3" data-aos="zoom-in"
     data-aos-duration="1000">Join Our Community</h2>
      <p className="px-3" data-aos="zoom-in"
     data-aos-duration="1000">Stay connected and be part of the Pharma Trades community.</p>
      <div className="d-flex align-items-center justify-content-center gap-3 pt-5 pb-5">
        <img src="/assets/images/twitter.svg" alt="twitter" />
        <img src="/assets/images/Telegram.svg" alt="Telegram" />
        <img src="/assets/images/GitHub.svg" alt="GitHub" />
        <img src="/assets/images/Discord.svg" alt="Discord" />
      </div>
      <div className="container">
        <div className="row pt-5 pb-5">
          <div
            className="col-lg-6  mb-3"
            data-aos="fade-right"
            data-aos-duration="1100"
          >
            <img src="/assets/images/footerlog.svg" alt="footerlog" />
          </div>
          <div
            className="col-lg-2 mb-3"
            data-aos="fade-left"
            data-aos-duration="1100"
          >
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#feature">Features</a></li>
            </ul>
          </div>
          <div
            className="col-lg-2 mb-3"
            data-aos="fade-left"
            data-aos-duration="1100"
          >
            <ul>
              <li><a href="#how-its-work">How It Works</a></li>
              <li><a href="#token">PHARMA Token</a></li>
              <li><a href="#use-cases">Use Cases</a></li>
            </ul>
          </div>
          <div
            className="col-lg-2  mb-3"
            data-aos="fade-left"
            data-aos-duration="1100"
          >
            <ul>
              <li><a href="#road-map">Roadmap</a></li>
              <li><a href="#faq">FAQ</a></li>
              {/* <li><a href="#contact">Contact</a></li> */}
            </ul>
          </div>
        </div>
        <hr className="pb-5 pt-5" />
        <div className="row bootom">
          <div className="col-lg-12 mb-3">
            <p className="text-center">
              © 2023 Pharma Trades. All rights reserved.
            </p>
          </div>
          {/* <div className="col-lg-5 mb-3">
            <div className="d-flex align-items-center flex-wrap justify-content-center gap-2">
              <a href="">
                <p>Terms of Service |</p>
              </a>
              <a href="">
                <p>Privacy Policy |</p>
              </a>
              <a href="">
                <p>Compliance</p>
              </a>
            </div>
          </div> */}
          {/* <div className="col-lg-2">
            <div className="d-flex align-items-center flex-wrap justify-content-center gap-4">
              <a href="">
                <svg
                  width="9"
                  height="15"
                  viewBox="0 0 9 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.62891 8.56836H5.57812V14.6934H2.84375V8.56836H0.601562V6.05273H2.84375V4.11133C2.84375 1.92383 4.15625 0.693359 6.15234 0.693359C7.10938 0.693359 8.12109 0.884766 8.12109 0.884766V3.04492H7C5.90625 3.04492 5.57812 3.70117 5.57812 4.41211V6.05273H8.01172L7.62891 8.56836Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5508 2.84961C12.5508 2.98633 12.5508 3.0957 12.5508 3.23242C12.5508 7.0332 9.67969 11.3809 4.40234 11.3809C2.76172 11.3809 1.25781 10.916 0 10.0957C0.21875 10.123 0.4375 10.1504 0.683594 10.1504C2.02344 10.1504 3.25391 9.68555 4.23828 8.91992C2.98047 8.89258 1.91406 8.07227 1.55859 6.92383C1.75 6.95117 1.91406 6.97852 2.10547 6.97852C2.35156 6.97852 2.625 6.92383 2.84375 6.86914C1.53125 6.5957 0.546875 5.44727 0.546875 4.05273V4.02539C0.929688 4.24414 1.39453 4.35352 1.85938 4.38086C1.06641 3.86133 0.574219 2.98633 0.574219 2.00195C0.574219 1.45508 0.710938 0.962891 0.957031 0.552734C2.37891 2.27539 4.51172 3.42383 6.89062 3.56055C6.83594 3.3418 6.80859 3.12305 6.80859 2.9043C6.80859 1.31836 8.09375 0.0332031 9.67969 0.0332031C10.5 0.0332031 11.2383 0.361328 11.7852 0.935547C12.4141 0.798828 13.043 0.552734 13.5898 0.224609C13.3711 0.908203 12.9336 1.45508 12.332 1.81055C12.9062 1.75586 13.4805 1.5918 13.9727 1.37305C13.5898 1.94727 13.0977 2.43945 12.5508 2.84961Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="">
                <svg
                  width="11"
                  height="15"
                  viewBox="0 0 11 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.57812 0.884766C8.14844 0.884766 10.5 2.66211 10.5 5.36914C10.5 7.91211 9.1875 10.7559 6.28906 10.7559C5.57812 10.7559 4.73047 10.4004 4.375 9.77148C3.77344 12.2324 3.80078 12.6152 2.43359 14.502C2.29688 14.5566 2.32422 14.5566 2.24219 14.4473C2.1875 13.9277 2.13281 13.4355 2.13281 12.916C2.13281 11.248 2.89844 8.81445 3.28125 7.20117C3.0625 6.76367 3.00781 6.27148 3.00781 5.80664C3.00781 3.61914 5.57812 3.29102 5.57812 5.0957C5.57812 6.16211 4.83984 7.17383 4.83984 8.21289C4.83984 8.89648 5.44141 9.38867 6.125 9.38867C8.01172 9.38867 8.58594 6.68164 8.58594 5.23242C8.58594 3.29102 7.21875 2.22461 5.33203 2.22461C3.17188 2.22461 1.50391 3.7832 1.50391 5.9707C1.50391 7.03711 2.16016 7.58398 2.16016 7.83008C2.16016 8.04883 1.99609 8.78711 1.72266 8.78711C1.06641 8.78711 0 7.69336 0 5.7793C0 2.74414 2.76172 0.884766 5.57812 0.884766Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.375 0.568359C11.8398 0.568359 12.25 0.978516 12.25 1.4707V11.9434C12.25 12.4355 11.8398 12.8184 11.375 12.8184H0.847656C0.382812 12.8184 0 12.4355 0 11.9434V1.4707C0 0.978516 0.382812 0.568359 0.847656 0.568359H11.375ZM3.69141 11.0684V5.24414H1.88672V11.0684H3.69141ZM2.78906 4.42383C3.36328 4.42383 3.82812 3.95898 3.82812 3.38477C3.82812 2.81055 3.36328 2.31836 2.78906 2.31836C2.1875 2.31836 1.72266 2.81055 1.72266 3.38477C1.72266 3.95898 2.1875 4.42383 2.78906 4.42383ZM10.5 11.0684V7.86914C10.5 6.31055 10.1445 5.08008 8.3125 5.08008C7.4375 5.08008 6.83594 5.57227 6.58984 6.03711H6.5625V5.24414H4.83984V11.0684H6.64453V8.19727C6.64453 7.43164 6.78125 6.69336 7.73828 6.69336C8.66797 6.69336 8.66797 7.56836 8.66797 8.22461V11.0684H10.5Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
